@if (navigationItem$ | async) {}

<div class="st-side-menu h-full">
  <div class="menu-header flex align-items-center gap-2">
    <button
      class="back-btn"
      (click)="back()"
      type="button"
    >
      <em class="ph ph-caret-left"></em>
    </button>
    @if (navigationItem()?.children?.length) {
      <div class="body-large-bold">{{ navigationItem()?.name }}</div>
    } @else if (tools()?.length && !hideTools()) {
      <div class="body-large-bold">Tools</div>
    }
  </div>
  @if (navigationItem()?.children?.length) {
    <div>
      @for (item of navigationItem()?.children; track $index) {
        <z-menu-collapse-item
          [menuItemData]="item"
          [active]="activeChild() !== null && activeChild()?.id === item.id"
        />
      }
    </div>
  } @else if (tools()?.length && !hideTools()) {
    <div class="flex flex-column gap-1 tools-list">
      @for (tool of tools(); track $index) {
        <a
          class="flex align-items-center gap-2 tools-list-item px-2 py-1"
          (click)="openTool(tool.publicUrl)"
        >
          <em class="ph ph-cursor icon-primary-color text-xl"></em>
          <div class="webkit-box-one-line body-medium-bold">
            {{ tool.name }}
          </div>
          <em class="ph ph-arrow-square-out ml-auto"></em>
        </a>
      }
    </div>
  }
</div>
